module.exports = __webpack_public_path__ + "img/voideBg1.2fb53ebc.jpg";